import { useEffect } from 'react'
import Select from 'react-select'
import { SectorDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const SectorDataDDL = (props) => {
    const { SectorName, setSectorName, WardName, PopUpField, rowData, Flag, IsDisabled } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WardID: WardName.ID,
            UserID: UserID,
            token: token
        }
        dispatch(SectorDDLAPI({ data }))
    }, [WardName.ID])

    const { SectorData } = useSelector(state => state.SectorDDLData)

    useEffect(() => {
        handleSectorDDL()
    }, [SectorData])

    const handleSectorDDL = () => {
        // console.log(DeptDDLDataa)
        if (SectorData && SectorData.table && SectorData.table.length > 0) {
            let list = SectorData.table.map((item, index) => ({
                value: item.id,
                label: item.sectorName,
            }))

            // setSectorName({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_gD_SectorID : 0,
            //     Label: Flag === 'Update' ? rowData.sectorName : "Select...",
            // })
            setSectorName({ ...SectorName, DDL: list })
        }
        else {
            setSectorName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Sector Name {Flag && <AstricSign />}</b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                isDisabled={IsDisabled}
                maxMenuHeight={150}
                value={{ value: SectorName.ID, label: SectorName.Label }}
                onChange={(e) => {
                    e ?
                        setSectorName({ ...SectorName, ID: e.value, Label: e.label })
                        :
                        setSectorName({ ...SectorName, ID: 0, Label: "Select..." })

                }}
                options={SectorName.DDL}
            />
        </div>
    )
}